import styled, { css, keyframes } from 'styled-components';

import { GameControlButton } from '../../../../../../../../../../shared/application/components/GameControlButton/GameControlButton';

interface WrapperProps {
  $isVisible: boolean;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme: { size, transition }, $isVisible }) => ({
    maxWidth: $isVisible ? size.units(12) : 0,
    opacity: $isVisible ? 1 : 0,
    overflow: $isVisible ? 'visible' : 'hidden',
    transition: transition.standard(),
  }),
);

export const CountBadge = styled(GameControlButton.Text)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

const pulseKeyframes = keyframes({
  '0%': { transform: 'scale(1)' },
  '50%': { transform: 'scale(1.15)' },
  '100%': { transform: 'scale(1)' },
});

export const AnimatedWrapper = styled.div(
  () => css`
    animation: ${pulseKeyframes} 0.4s ease-out;
  `,
);
